<template>
  <div id="app" v-if="dictionaryLoaded">
    <div v-if="_isIE()" class="ie-alert">
      <p>Váš prohlížeč není podporován! Prosíme použijte modernější a bezpečnější internetový prohlížeč (např: <a
        href="https://www.google.com/intl/cs_CZ/chrome/">Google Chrome</a>,
        <a href="https://www.mozilla.org/cs/firefox/new/">Firefox Browser</a>)</p>
    </div>
    <my-header v-if="user.logged && !unloginpages.includes($route.name)"></my-header>
    <left-menu v-if="user.logged"></left-menu>
    <router-view @logout="logout" />
  </div>
</template>

<script>
import { http } from '@/http'
import DictionaryLoader from '@/model/loader/dictionary-loader'
import MyHeader from './components/views/layout-header'
import LeftMenu from './components/views/layout-left-menu'



export default {
  components: {
    MyHeader,
    LeftMenu
  },

  data() {
    return {
      dictionaryLoaded: false,
      pluginsInitialize: false,
      defaultLanguageCode: 'CZ',
      site: Site.getInstance(),
      company: this.$route.params.company,
      user: this.$store.getters.user,
      unloginpages: [
        '404',
        'CompleteRegistrationPage',
        'SignInPage',
        'ResetPassword',
        'Registration'
      ]
    }
  },

  created() {
    this.$store.commit('setUrlAppName', { appName: this.$route.params.company })
    this._setHttpHeaders()
    this._checkLogged()
    this._checkCompany()

    if (this.user.logged) {
      this._callDictionary()
    }

    if (this.unloginpages.includes(this.$route.name)) {
      this.dictionaryLoaded = true
    }

    document.body.classList.add('dashboard')
  },

  updated() {
    this._setHttpHeaders()

    if (!this.pluginsInitialize) {
      this.site.initializePluginAPIs()
      this.site.initializePlugins()
      this.site.initComponents()
      this.pluginsInitialize = true
    }

    if ((!this.$translate.locale || this.$user.languageCode !== this.$translate.current) && this.user.logged) {
      this._callDictionary()
    }

    this.user = this.$store.getters.user
  },

  methods: {
    logout() {
      this.$store.commit('logout')
      clearInterval(this.$store.getters.getHeaderNotificationTimer)
      window.location.href = '/' + this.company + '/sign-in'
    },

    _setHttpHeaders () {
    // Určení, zda aplikace běží v prostředí vývoje (development)
    const isDevelopment = ['test.repnode.com', 'beta.repnode.com', 'localhost'].includes(window.location.hostname);
    // Nastavení základní URL pro HTTP požadavky v závislosti na prostředí
   // http.defaults.baseURL = isDevelopment ? 'https://apitest.repnode.com/Repnodeapi/api' : 'https://api.repnode.com/RepnodeAPI/api';
  http.defaults.baseURL = 'https://apitest.repnode.com/Repnodeapi/api';
      // Získání informací o uživateli z Vuex úložiště
    const user = this.$store.getters.user;

    // Nastavení vlastních hlaviček pro aplikaci a autorizaci
    http.defaults.headers.appName = this.$store.getters.urlAppName;
    http.defaults.headers.Authorization = `${user.identity.tokenType} ${user.identity.accessToken}`;

    // Interceptor pro zpracování odpovědí a chyb
    http.interceptors.response.use(
        response => response,
        error => {
            if (error.response && error.response.status === 401) {
                // Pokud je status 401 (neautorizováno), provede se odhlášení
                this.logout();
            }
            return Promise.reject(error);
        }
    );
},


    _checkCompany() {
      if (this.$route.name === 'Registration') return;

      const user = this.$user;
      if (user.logged && user.identity.appName !== this.$store.getters.urlAppName) {
        this.$router.push({ name: 'Logout' });
      }

      if (!this.company) {
        this.$router.push({ name: '404' });
      }
    },

    _checkLogged() {
      if (!this.user.logged && !this.unloginpages.includes(this.$route.name)) {
        this.$router.push({ name: 'SignInPage' });
      }
    },

    _callDictionary() {
      DictionaryLoader.load((locale) => {
        this.$translate.setLocales(locale);
        this.$translate.setLang(this.$user.languageCode);
        this.dictionaryLoaded = true;
      });
    },

    _isIE() {
      const ua = window.navigator.userAgent;
      return ua.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
    }
  }
}
</script>

<style>
/* Stylesheets */
@import 'assets/bootstrap.css';
@import 'assets/bootstrap-extend.css';
@import 'assets/site.css';

/* Plugins */
@import 'assets/animsition.css';
@import 'assets/asScrollable.css';
@import 'assets/introjs.css';
@import 'assets/slidePanel.css';
@import 'assets/flag-icon.css';
@import 'assets/jquery-jvectormap.css';
@import 'assets/jsgrid.css';
@import 'assets/formValidation.css';
@import 'assets/select2.css';
@import 'assets/bootstrap-select.css';
@import 'assets/bootstrap-table.css';
@import 'assets/bootstrap-table-sticky-header.css';
@import 'assets/bootstrap-datepicker.css';
@import 'assets/typeahead.css';
@import 'assets/jquery-wizard.css';
@import 'assets/v1.css';
@import 'assets/taskboard.css';
@import 'assets/clockpicker.css';
@import 'assets/jquery-timepicker.css';
@import 'assets/gridstack.css';
@import 'assets/gridstack-extra.css';
@import 'assets/mapbox-js/mapbox.css';
@import 'assets/mapbox-js/mapbox-gl.css';
@import 'assets/mapbox-js/location.css';
@import 'assets/dropify.css';
@import 'assets/login-v3.css';
@import 'assets/bootstrap-treeview.min.css';
@import '~sweetalert2/dist/sweetalert2.css';
@import '~tippy.js/dist/tippy.css';
@import '~labelauty/source/jquery-labelauty.css';
@import '~switchery/switchery.css';

/* Fonts */
@import 'assets/fonts/weather-icons/weather-icons.css';
@import 'assets/fonts/web-icons/web-icons.css';
@import 'assets/fonts/brand-icons/brand-icons.css';
@import 'assets/fonts/font-awesome/font-awesome.css';
@import 'assets/fonts/material-design/material-design.css';
@import 'assets/fonts/7-stroke/7-stroke.css';

/* Orbinet */
@import 'assets/orbinet.css';
@import '~magnific-popup/dist/magnific-popup.css';

#app {
  height: calc(100vh - 63px);
}

.panel-body {
  width: 100%;
  padding: 0 15px 15px;
  margin: 0;
}

.page-content__dynamic-editor .panel-body {
  padding: 0 0 15px;
}

.panel-body .panel-body.grid .products-wrapper {
  box-shadow: none;
}

.page-content .panel-body.tree-grid {
  padding: 15px;
}

.ie-alert {
  color: #FFFFFF;
  background: #ff4d48;
  width: 100%;
  text-align: center;
}

.ie-alert p {
  font-weight: bold;
  font-size: 20px;
  padding: 15px;
}

.ie-alert a {
  color: #FFFFFF;
}
</style>
